import { RemoteLoadTerm } from '../../../data/usecases/terms/remote-load-terms'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeLoadTermBySlug = (): RemoteLoadTerm => {
  return new RemoteLoadTerm('/public/pages', makeAxiosHttpClient())
}
